import { render, staticRenderFns } from "./PopupDeleteShift.vue?vue&type=template&id=5b909d7a&scoped=true&"
import script from "./PopupDeleteShift.vue?vue&type=script&lang=ts&"
export * from "./PopupDeleteShift.vue?vue&type=script&lang=ts&"
import style0 from "./PopupDeleteShift.vue?vue&type=style&index=0&id=5b909d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b909d7a",
  null
  
)

export default component.exports